import React from 'react';
import {
    BarChart3,
    AlertTriangle,
    Wrench,
    FileText,
    Save,
    Calendar,
    Settings,
    Shield,
    User,
    LogOut,
    Factory,
    MapPin,
    ScanSearch,
    X
} from 'lucide-react';

const Sidebar = ({ isOpen, onClose, activePage, onPageSelect, userInfo, onLogout }) => {
    const menuItems = [
        { id: 'statistics', name: 'Статистика', icon: BarChart3 },
        { id: 'ns', name: 'Нештатные ситуации', icon: AlertTriangle },
        { id: 'devices', name: 'Объект учета', icon: Factory },
        { id: 'reports', name: 'Отчетные формы', icon: FileText },
        { id: 'map', name: 'Карта объектов', icon: MapPin, roles: [1, 2] },
        { id: 'heatschedule', name: 'График отключения ТЭЦ', icon: Calendar },
        { id: 'analysis', name: 'Сравнительный анализ', icon: ScanSearch },
        { id: 'mainsettings', name: 'Настройки', icon: Settings },
    ];

    // Добавляем "Администрирование" только для админов
    if (userInfo?.levelRight >= 1) {
        menuItems.push({ id: 'admin', name: 'Администрирование', icon: Shield });
    }

    return (
        <aside
            className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-72 bg-slate-800 border-r border-slate-700 
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        flex flex-col
      `}
        >
            {/* Заголовок */}
            <div className="p-4 bg-gradient-to-r from-blue-900/50 to-slate-800 border-b border-slate-700">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold text-lg">
                            {userInfo?.name?.[0]?.toUpperCase() || 'U'}
                        </div>
                        <div>
                            <div className="text-white font-semibold">{userInfo?.description || 'Пользователь'}</div>
                            <div className="text-slate-400 text-xs flex items-center gap-1">
                                {userInfo?.levelRight === 1 ? (
                                    <>
                                        <Shield className="w-3 h-3" />
                                        <span>Админ</span>
                                    </>
                                ) : (
                                    <>
                                        <User className="w-3 h-3" />
                                        <span>Оператор</span>
                                    </>
                                )}
                                {userInfo?.groupNum && <span>• Группа: {userInfo.groupNum}</span>}
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="lg:hidden text-slate-400 hover:text-white p-2"
                        aria-label="Закрыть меню"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
            </div>

            {/* Меню */}
            <nav className="flex-1 overflow-y-auto py-4">
                {menuItems.map(item => {
                    const IconComponent = item.icon;
                    return (
                        <button
                            key={item.id}
                            onClick={() => onPageSelect(item.id)}
                            className={`
                w-full flex items-center gap-3 px-4 py-3 text-left transition
                ${activePage === item.id
                                    ? 'bg-blue-600/20 text-blue-400 border-r-4 border-blue-500'
                                    : 'text-slate-400 hover:bg-slate-700/50 hover:text-white'
                                }
              `}
                        >
                            <IconComponent className="w-5 h-5" />
                            <span className="text-sm font-medium">{item.name}</span>
                        </button>
                    );
                })}
            </nav>

            {/* Кнопка выхода (мобильная) */}
            <div className="p-4 border-t border-slate-700 lg:hidden">
                <button
                    onClick={onLogout}
                    className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-red-600/20 hover:bg-red-600/30 text-red-400 hover:text-red-300 rounded-lg transition"
                >
                    <LogOut className="w-5 h-5" />
                    <span className="font-medium">Выйти из системы</span>
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;